import {useEffect, useState} from "react";
import {authAPI, accountDeliveryAddressAPI, contactAPI} from "../../api/api";
import { Toast } from 'primereact/toast';
import styles from "./Profile.module.css"
import './Profile.css';
import { SpinnerUA } from "../../common/Spinners/SpinerUA/SpinnerUA";
import { useRef } from "react";
import { Checkbox } from "primereact/checkbox";
import { Button } from 'primereact/button';
import { PdfFiles } from "./Docs/PdfFiles";
import { InputSwitch } from "primereact/inputswitch";


export const Profile = ({clientId}) => {
    const [profileData, setProfileData] = useState("");
    const [accountDeliveryAddressList, setAccountDeliveryAddressList] = useState([])
    const [isLoading, setIsLoading] = useState(true);

    const [promotionalOffersFlag, setPromotionalOffersFlag] = useState(false);
    const [oldPromotionalOffersFlag, setOldPromotionalOffersFlag] = useState(false);

    const toast = useRef();

    useEffect(() => {
        if(clientId !== "") {
            fetchDeliveryAddress();
            getClientInfo();
        }
    }, [clientId]);

    const sendViberFlagToCrm = async (value) => {
        setIsLoading(true);
        saveContactByModel(value).finally(setIsLoading(false))
    }

    const saveContactByModel = async (value) => {
        debugger
        const modeltoUpdate = {
            SendToViber: value ? 1 : 0
        }

        var {data} = await contactAPI.updateContactByModel(JSON.stringify(modeltoUpdate))
        const resp = JSON.parse(data);

        if(resp.isSucccess){
            getClientInfo().then();
            toast.current.clear();
                toast.current.show({
                    severity: 'success',
                    summary: 'Успіх',
                    clearPrevious: true,
                    detail: 'Дані оновлено',
                    life: 900,
                });
        }
        else{
            toast.current.clear();
            toast.current.show({
                severity: 'error',
                summary: 'Помилка',
                clearPrevious: true,
                detail: 'Не вдалося оновити дані. Причина:  ' + resp.message,
                life: 5000
            });
        }
    }

    const fetchDeliveryAddress = async () => {
        const {data} = await accountDeliveryAddressAPI.getActive();
        let resp = JSON.parse(data);
        if(resp.isSucccess){
            setAccountDeliveryAddressList(resp.data);
        }
    }

    const getClientInfo = async () => {
        try{
            console.log("start axios CATALOG")

            const { data } = await authAPI.getClientInfo((clientId))
            const responce = JSON.parse(data)
            console.log(responce)

            if(responce.isSucccess)
            {
                setProfileData(responce.data)

                setPromotionalOffersFlag(!!responce.data.SendToViber)
                setOldPromotionalOffersFlag(!!responce.data.SendToViber)
            }
            else{
                toast.current.clear();
                toast.current.show({severity: 'error', summary: 'Помилка завантаження данних профілю', detail: responce.message, life: 3000});
            }
        }
        catch(ex)
        {
            toast.current.clear();
            toast.current.show({severity: 'error', summary: 'Помилка завантаження данних профілю', detail: "Помилка", life: 3000});
        }
        setIsLoading(false);
    };

    

    return(
        <div className={styles.profileWrapper}>

             {isLoading ? <div className={styles.spinner}>
                <SpinnerUA />
            </div> : null}

            <Toast ref={toast}></Toast>
            {profileData ? <div className={styles.allInfoWrapper}>
                <div className={styles.clientInfoWrapper}>
                    <div className={`${styles.welcome} ${styles.boxShadow} ${styles.padding}`}>
                        <h5>{profileData.ClientFirstName} {profileData.ClientLastName}, вітаємо в особистому кабінеті </h5>
                    </div>
                    <div className={`${styles.clientContactInfo} ${styles.boxShadow} ${styles.padding}`}>
                          <h5>Ваші дані</h5>
                          <div className={styles.infoBlock}>
                            {profileData.ClientWorkPhone ? <a className={styles.infoLine} href={`tel:${profileData.ClientWorkPhone.replace(/\D/g, "")}`}>{profileData.ClientWorkPhone}</a>  : null}
                            {profileData.ClientPrivatePhone ? <a className={styles.infoLine} href={`tel:${profileData.ClientPrivatePhone.replace(/\D/g, "")}`}>{profileData.ClientPrivatePhone}</a> : null}
                            {profileData.ClientWorkEmail?  <a className={styles.infoLine} href={`mailto:${profileData.ClientWorkEmail}`}>{profileData.ClientWorkEmail}</a> : null}
                            {profileData.ClientPrivateEmail ? <a className={styles.infoLine} href={`mailto:${profileData.ClientPrivateEmail}`}>{profileData.ClientPrivateEmail}</a> : null}
                          </div>
                          <h5>{profileData.ClientOrganizationName}</h5>
                          <div className={styles.infoBlock}>
                            {profileData.ClientOrganizationPhone? <a className={styles.infoLine} href={`tel:${profileData.ClientOrganizationPhone.replace(/\D/g, "")}`}>{profileData.ClientOrganizationPhone}</a> : null}
                            {profileData.ClientOrganizationOtherPhone? <a className={styles.infoLine}  href={`tel:${profileData.ClientOrganizationOtherPhone.replace(/\D/g, "")}`}>{profileData.ClientOrganizationOtherPhone}</a>: null}
                            {profileData.ClientOrganizationEmail? <a className={styles.infoLine} href={`mailto:${profileData.ClientOrganizationEmail}`}>{profileData.ClientOrganizationEmail}</a>: null}
                          </div>
                    </div>
                    {accountDeliveryAddressList.length > 0? <div className={`${styles.deliveryAddressList} ${styles.boxShadow} ${styles.padding}`}>
                        <h5>Адреси доставки</h5>
                        <div className={styles.infoBlock}>
                            {accountDeliveryAddressList.map((address, index) =>
                                <li key={address.Id.toString()}>{address.FullName}</li>     
                            )}
                        </div>
                    </div>: null}
                </div>
                <div className={styles.ourInformationWrapper}>
                    <div className={`${styles.managerInfo} ${styles.boxShadow} ${styles.padding}`}>
                        <h5>Ваш менеджер</h5>
                        <div className={styles.infoBlock}>
                            {profileData.ManagerFirstName ? <span className={styles.infoLine}>{profileData.ManagerFirstName} {profileData.ManagerLastName}</span>: null}
                            {profileData.ManagerWorkPhone ? <a className={styles.infoLine} href={`tel:${profileData.ManagerWorkPhone.replace(/\D/g, "")}`}>{profileData.ManagerWorkPhone}</a>: null}
                            {profileData.ManagerPrivatePhone ? <a className={styles.infoLine} href={`tel:${profileData.ManagerPrivatePhone.replace(/\D/g, "")}`}>{profileData.ManagerPrivatePhone}</a>: null}
                            {profileData.ManagerEmail? <a className={styles.infoLine} href={`mailto:${profileData.ManagerEmail}`}>{profileData.ManagerEmail}</a>: null}
                        </div>
                    </div>
                    <div className={`${styles.careDepartment} ${styles.boxShadow} ${styles.padding}`}>
                        <h5>Відділ турботи</h5>
                        <div className={styles.infoBlock}>
                            <span>{profileData.ManagerResponsibleOfficeManager}</span>
                            <a href={`tel:${profileData.FirmCityPhone.replace(/\D/g, "")}`}>{profileData.FirmCityPhone}</a>
                        </div>
                        <p></p>
                        <div className={styles.infoBlock}>
                            <div className={styles.flexRow}>
                                <div style={{minWidth:'5rem'}}>Kyivstar:</div>
                                <div>  <a href={`tel:${profileData.FirmKyivstarPhone.replace(/\D/g, "")}`}>{profileData.FirmKyivstarPhone}</a> </div>
                            </div>
                            <div className={styles.flexRow}>
                                <div style={{minWidth:'5rem'}}>Vodafone:</div>
                                <div>  <a href={`tel:${profileData.FirmVodafonePhone.replace(/\D/g, "")}`}>{profileData.FirmVodafonePhone}</a> </div>
                            </div>
                            <div className={styles.flexRow}>
                                <div style={{minWidth:'5rem'}}>Lifecell:</div>
                                <div> <a href={`tel:${profileData.FirmLifecellPhone.replace(/\D/g, "")}`}>{profileData.FirmLifecellPhone}</a></div>
                            </div>
                            <div className={styles.flexRow}>
                                <div style={{minWidth:'5rem'}}>Міський:</div>
                                <div> <a href={`tel:${profileData.FirmCityPhone.replace(/\D/g, "")}`}>{profileData.FirmCityPhone}</a> </div>
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.assist} ${styles.boxShadow} ${styles.padding}`}>
                        <div style={{}}>
                            <span>З питань роботи особистого кабінету звертатись на пошту: <a className={styles.infoLine} href={`mailto:${profileData.FirmPersonalAccountAssistEmail}`}>{profileData.FirmPersonalAccountAssistEmail}</a> </span>
                        </div>
                    </div>
                    <div className={`${styles.agreements} ${styles.boxShadow} ${styles.padding}`}>
                        <PdfFiles />
                        <div style={{marginBottom:'5px', display:'flex', alignItems:"stretch"}}>
                            <label htmlFor="promotionalOffers" className="mr-2">Хочу отримувати акційні пропозиції</label>
                            <InputSwitch  style={{fontSize:'10px'}} checked={promotionalOffersFlag} onChange={(e) => sendViberFlagToCrm(e.value)} />
                         </div>
                    </div>
                </div>
            </div>: null}
        </div>
    )
}